/**
 * Managed fetch that will reject the promise chain for anything other than a 2xx response, with as much user-relevant
 * information in the error object as possible.
 *
 * Optionally parses response as JSON, returns null otherwise.
 *
 * Has the same request API as standard fetch. Returned promise is the parsed response body object (if non-null) rather
 * than the raw response object.
 *
 * @param url Resource to request
 * @param params Optional fetch params.
 * @returns {Promise<Object|null>} Either returns parsed response body object, or null if empty or anything else.
 */
const jsonFetch = async (url, params) => {
	// XSS is low risk here (all internal staff data) so session storage is OK for our use case
	const token = localStorage.getItem('token');
	
	let headers = {
		...((params && params.headers) || {}),
		'Authorization': token ? `${token}` : undefined
	};
	
	if (params && params.body && params.method && (params.method === 'POST' || params.method === 'PUT')) {
		headers = {
			...headers,
			'Content-Type': 'application/json'
		}
	}
	
	const response = await fetch(url, {
		...params,
		headers
	});
	
	// Optionally parse json if non-empty response
	const text = await response.text();
	let json = null;
	if (text && text.length) {
		json = JSON.parse(text);
	}
	
	if (response.ok) {
		return json;
	} else {
		// noinspection ExceptionCaughtLocallyJS
		const e = new Error(json.message);
		e.status = response.status;
		throw e;
	}
};

export default jsonFetch;



// WEBPACK FOOTER //
// ./src/jsonFetch.js